import React from "react";

const AgeVerification = ({ onVerify }) => {
  return (
    <div 
      className="fixed inset-0 z-[100] bg-[#050505] flex items-center justify-center"
      data-testid="age-verification-modal"
    >
      <div className="text-center px-6 max-w-lg animate-fadeIn">
        {/* Logo/Brand */}
        <div className="mb-12">
          <h1 className="font-heading text-5xl md:text-6xl tracking-tighter text-white mb-4">
            8eight8
          </h1>
          <p className="font-subheading text-sm tracking-[0.3em] uppercase text-[#A3A3A3]">
            Beverage Co
          </p>
        </div>

        {/* Age Gate Content */}
        <div className="mb-12">
          <h2 className="font-heading text-3xl md:text-4xl text-white mb-6">
            Welcome
          </h2>
          <p className="text-[#A3A3A3] text-lg mb-2">
            Are you of legal drinking age?
          </p>
          <p className="text-[#737373] text-sm">
            You must be 21 years or older to enter this site.
          </p>
        </div>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => onVerify(true)}
            className="btn-maduro text-lg px-10 py-4"
            data-testid="age-verify-yes"
          >
            Yes, I am 21+
          </button>
          <button
            onClick={() => onVerify(false)}
            className="btn-outline text-lg px-10 py-4"
            data-testid="age-verify-no"
          >
            No
          </button>
        </div>

        {/* Legal text */}
        <p className="text-[#737373] text-xs mt-12 max-w-md mx-auto leading-relaxed">
          By entering this site, you agree to our Terms of Service and Privacy Policy. 
          Please drink responsibly.
        </p>
      </div>

      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#C8A876] rounded-full blur-[150px]" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#FF6B35] rounded-full blur-[150px]" />
      </div>
    </div>
  );
};

export default AgeVerification;
